module.exports = __webpack_public_path__ + "static/media/belfast.52797d5c.png";